import * as React from 'react'

import SearchIcon from '../assets/search.svg'

// NOT using the <Svg /> component, because want the default "eager" loading.
const SearchSvg = ({ size }: { size: number }) => <img src={SearchIcon} width={size} height={size} color="midnight" />

export default SearchSvg
